import { OrderV2 } from "@/types/inventoryV2";
import { BoxShipStatus, PackBox, PackOrder, PackSourceItem } from "@/types/packing";
import { PurchaseOrderItem } from "@/types/purchase";
import { SaleItemState, SaleOrderItemState } from "@/types/sales";
import { Logistics } from "@/types/shipment";
import { createContext, Dispatch, FC, RefObject, SetStateAction } from "react";

export type BoxListSelectRef = {
  getSelectBox: () => PackBox[];
  clearSelect: () => void;
}

export interface TPackOrderContext {
  orderData: PackOrder;
  // logistcsOrder: Logistics | null
  setOrderData: Dispatch<SetStateAction<PackOrder | null>>;
  sourceInventory: OrderV2 | null;
  sourceItems: PackSourceItem[];
  setSourceItems: Dispatch<SetStateAction<PackSourceItem[]>>;
  boxListRef: RefObject<BoxListSelectRef> | undefined;
  boxShipStatus: BoxShipStatus[]
  setBoxShipStatus: Dispatch<SetStateAction<BoxShipStatus[]>>;
  saleItems: SaleItemState[];
  mainCurrency: string;
  purLotMap: Record<string, PurchaseOrderItem>;
};


export const PackOrderContext = createContext<TPackOrderContext>({
  orderData: {} as PackOrder,
  // logistcsOrder: null,
  setOrderData: () => { },
  sourceInventory: {} as OrderV2,
  sourceItems: [],
  setSourceItems: () => { },
  boxListRef: undefined,
  boxShipStatus: [],
  setBoxShipStatus: () => { },
  saleItems: [],
  mainCurrency: '',
  purLotMap: {},
});
